import { IntegrationType } from '@aibees/elephant/types/integration';

/**
 * Maps IntegrationType enum values to their display names
 */
const INTEGRATION_TYPE_NAMES: Record<IntegrationType, string> = {
  [IntegrationType.SMART_LEAD]: 'smart-lead',
  [IntegrationType.SALES_FORCE]: 'sales-force',
  [IntegrationType.HUB_SPOT]: 'hub-spot',
};

/**
 * Hook that provides integration type name mapping
 * @param integrationType - The integration type to get name for
 * @returns The display name for the integration type
 */
export const useIntegrationTypeName = (integrationType?: string) => {
  const getTypeName = (type?: string): string => {
    if (!type) return 'Unknown';

    const normalizedType = type.toUpperCase() as IntegrationType;
    return INTEGRATION_TYPE_NAMES[normalizedType] || type;
  };

  return getTypeName(integrationType);
};
